import { useState } from 'react';
import { UserAudio, AudioTab } from '../../@types';
import { getPrivateAudiosResponse } from 'apps/t2c-fe/services/audio/getPrivateAudios';
import { InfiniteData } from '@tanstack/react-query';

export const useAudioTabs = (
  publicAudioList: UserAudio[],
  privateAudioList: InfiniteData<getPrivateAudiosResponse>
) => {
  const [activeTab, setActiveTab] = useState<AudioTab>(AudioTab.Public);
  const [selectedAudio, setSelectedAudio] = useState<UserAudio | null>(
    publicAudioList?.[0] ?? privateAudioList?.pages[0]?.data?.[0]
  );

  const handleTabChange = (event: React.SyntheticEvent, newValue: AudioTab) => {
    setActiveTab(newValue);
  };

  const handleAudioTrackSelect = (audio: UserAudio) => {
    setSelectedAudio(audio);
  };

  const audioList =
    activeTab === AudioTab.Private
      ? privateAudioList?.pages?.map((res) => res.data).flat()
      : publicAudioList;

  return {
    activeTab,
    selectedAudio,
    handleTabChange,
    handleAudioTrackSelect,
    audioList,
  };
};
